import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { AnnotatedFormItem } from "./AnnotatedFormItem";
import { css } from "@emotion/core";
import { longLabel } from "../../style/form";
import { Input, Form, Select } from "antd";
import { isUserType, userTypes } from "../../stores/ContactViewStore";

export const MainNameFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <div>
      <AnnotatedFormItem
        label="ご本人様氏名"
        annotation={
          <>
            姓名の間にスペースを空けてください
            <br />
            ご入籍済みの方は旧姓を記入お願いします
          </>
        }
      >
        <Input
          value={store.mainName}
          onChange={e => {
            store.mainName = e.target.value;
          }}
        />
      </AnnotatedFormItem>
      <Form.Item label="ご本人様区分" css={longLabel}>
        <Select
          value={store.mainUserType}
          onChange={(value: any) => {
            if (!isUserType(value)) return;
            store.mainUserType = value;
          }}
        >
          {userTypes.map((r, i) => (
            <Select.Option key={i} value={r}>
              {r}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
});
